import React from 'react';
import Loading from '../loadings';
import $ from "jquery";
import Server from '../../functions/server';
import { Input, Button, Form, TextArea } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReadCookie from '../../functions/readcookies';

class View extends React.Component {

  state = {
    data: [],
    executicePoints: [],
    dialog: false,
    fullWidth: true,
    maxWidth: 'lg',
    maxWidth2: 'md',
    maxWidth1: 'xs',
    redeem: 0,
  }

  componentDidMount() {
    this.getExecutive();
  }

  getExecutive() {
    let context = this;
    context.setState({ load: true, message: 'Get all Executive!!!' })
    $.ajax({
      type: 'POST',
      url: Server() + 'settings/getallexecutivepoints.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
        } catch (e) {
          alert('Error')
        }
        console.log(data);
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  textHandle = (id, type) => event => {
    let data = this.state.data;
    data.map((d) => {
      if (d.id == id) {
        if (type == 'executivecreationpoints') {
          d.executivecreationpoints = event.target.value;
        }
        else {
          d.selfcreationpoints = event.target.value;
        }
      }
    })
    this.setState({ data: data })
  }

  view(empid) {
    let context = this;
    context.setState({ load: true, message: 'Get all Executive Points!!!' })
    $.ajax({
      type: 'POST',
      data: { 'empid': empid },
      url: Server() + 'settings/getexecutivepoints.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ executicePoints: data, openDialog: true })
        } catch (e) {
          alert('Error')
        }
        console.log(data);
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  redeempoints(id, points) {
    this.setState({ redeemDialog: true, empid: id, availableredeempoints: points })
  }

  bonuspoints(id) {
    this.setState({ bonusDialog: true, empid: id })
  }


  submitBounsPoints() {
    let context = this;
    let empid = this.state.empid;
    let bonus = this.state.bonus;
    let originalData = this.state.data;
    let description = this.state.discc;
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    context.setState({ load: true, message: 'Get all Executive!!!' })
    $.ajax({
      type: 'POST',
      data: { 'empid': empid, 'bonus': bonus, 'by': by, 'description': description },
      url: Server() + 'settings/bonuspoints.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          originalData.map((z) => {
            let total = z.balancepoint;
            try {
              total = Number(total);
              bonus = Number(bonus);
            } catch (e) {
            }
            total = total + bonus;
            if (z.id == empid) {
              z.balancepoint = total;
            }
          })
          context.setState({ discc: '', bonusDialog: false, empid: 0, availableredeempoints: 0, bonus: 0, data: originalData })
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  submitRedeemPoints() {
    let context = this;
    let empid = this.state.empid;
    let redeem = this.state.redeem;
    let redeemPoints = '-'+this.state.redeem;
    let description = this.state.discc;
    try {
      redeemPoints = Number(redeemPoints);
    } catch (e) {

    }
    let originalData = this.state.data;
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    context.setState({ load: true, message: 'Get all Executive!!!' })
    $.ajax({
      type: 'POST',
      data: { 'empid': empid, 'redeem': redeemPoints, 'by': by, 'description': description },
      url: Server() + 'settings/redeempoints.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          originalData.map((z) => {
            let total = z.balancepoint;
            try {
              total = Number(total);
              redeem = Number(redeem);
            } catch (e) {
            }
            total = total - redeem;
            if (z.id == empid) {
              z.balancepoint = total;
            }
          })
          context.setState({ discc: '', redeemDialog: false, empid: 0, availableredeempoints: 0, redeem: 0, data: originalData })
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  onChangeHandle = (type) => event => {
    let value = event.target.value;
    if (value < 0) {
      alert('value is Negative!!!');
      return;
    }
    else {
      let availableredeempoints = this.state.availableredeempoints;
      try {
        value = Number(value);
        availableredeempoints = Number(availableredeempoints);
      } catch (e) {

      }
      if (value > availableredeempoints) {
        alert('Redeem Points is Greater then Available Points!!!');
      }
      else {
        this.setState({ [type]: value })
      }
    }
  }

  onChangeHandle1 = (type) => event => {
    this.setState({ [type]: event.target.value })
  }

  render() {
    let i = 1;
    let j = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{padding: '2%'}}>
          <table id='table' width='100%'>
            <tr>
              <th style={{width: '10%'}} id='th'><center>Sino</center></th>
              <th style={{width: '35%'}} id='th'><center>Executive</center></th>
              <th style={{width: '20%'}} id='th'><center>Balance Points</center></th>
              <th style={{width: '15%'}} id='th'><center>Redeem Points</center></th>
              <th style={{width: '15%'}} id='th'><center>Bonus Points</center></th>
              <th style={{width: '10%'}} id='th'><center>View</center></th>
            </tr>
            { this.state.data.map((c) => {
                let balancepoint = c.balancepoint;
                try {
                  balancepoint = Number(balancepoint).toFixed(2);
                } catch (e) {

                }
                return (
                  <tr id='tbody'>
                    <td><center>{i++}</center></td>
                    <td>{c.id+'->'+c.name}</td>
                    <td><center align='right'>{balancepoint}</center></td>
                    <td onClick={this.redeempoints.bind(this, c.id, balancepoint)}><u><center>{'Redeem'}</center></u></td>
                    <td onClick={this.bonuspoints.bind(this, c.id)}><u><center>{'Bonus'}</center></u></td>
                    <td onClick={this.view.bind(this, c.id)}><center>View</center></td>
                  </tr>
                )
              })
            }
          </table><br/>
        </div>


        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.bonusDialog}
          onClose={ () => { this.setState({ bonusDialog: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Bonus Points</DialogTitle>
          <DialogContent>
            <Input type='number' placeholder='Points' onChange={this.onChangeHandle1('bonus')} value={this.state.bonus} fluid /><br/>
            <Form>
              <TextArea fluid onChange={this.onChangeHandle1('discc')} value={this.state.discc} placeholder='Description' />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button color='blue' onClick={this.submitBounsPoints.bind(this)}>Submit</Button>
            <Button color='blue' onClick={ () => { this.setState({ bonusDialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.redeemDialog}
          onClose={ () => { this.setState({ redeemDialog: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Redeem Points</DialogTitle>
          <DialogContent>
            <Input type='number' placeholder='Points' onChange={this.onChangeHandle('redeem')} value={this.state.redeem} fluid /><br/>
            <Form>
              <TextArea fluid onChange={this.onChangeHandle1('discc')} value={this.state.discc} placeholder='Description' />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button color='blue' onClick={this.submitRedeemPoints.bind(this)}>Submit</Button>
            <Button color='blue' onClick={ () => { this.setState({ redeemDialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>


        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth2}  open={this.state.open}
          onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Remarks</DialogTitle>
          <DialogContent>
              {this.state.dis}
          </DialogContent>
          <DialogActions>
            <Button color='blue' onClick={ () => { this.setState({ open: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.openDialog}
          onClose={ () => { this.setState({ openDialog: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Points</DialogTitle>
          <DialogContent>
            <table id='table' width='100%'>
              <tr>
                <th id='th'>Sino</th>
                <th id='th'>Branch</th>
                <th id='th'>Invoice No</th>
                <th id='th'>Name</th>
                <th id='th'>Self/Executive</th>
                <th id='th'>Branch</th>
                <th id='th'>Invoice Value</th>
                <th id='th'>Total Point</th>
                <th id='th'>Remark</th>
              </tr>
              { this.state.executicePoints.map((c) => {
                  let type = c.type;
                  let invoice_value = c.invoice_value;
                  let closing_total = c.closing_total;
                  let point = c.point;
                  let backgroundColor = 'white';
                  if (c.type == 'redeem') {
                    backgroundColor = '#EDCBBA';
                  }
                  else if (c.type == 'bonus') {
                    backgroundColor = '#B9DBA6';
                  }
                  try {
                    invoice_value = Number(invoice_value).toFixed(2);
                    closing_total = Number(closing_total).toFixed(2);
                    point = Number(point).toFixed(2);
                  } catch (e) {

                  }
                  if (backgroundColor == 'white') {
                    if (c.method == 'branch') {
                      return (
                        <tr style={{backgroundColor: backgroundColor}}>
                          <td><center>{j++}</center></td>
                          <td>{c.branch_id+'->'+c.branch_name}</td>
                          <td><center>{c.type_value}</center></td>
                          <td><center>{c.name}</center></td>
                          <td><center></center></td>
                          <td><center align='right'>{point}</center></td>
                          <td>{'Rs. '+invoice_value}</td>
                          <td><center align='right'>{closing_total}</center></td>
                          <td><center>{}</center></td>
                        </tr>
                      )
                    }
                    else {
                      return (
                        <tr style={{backgroundColor: backgroundColor}}>
                          <td><center>{j++}</center></td>
                          <td>{c.branch_id+'->'+c.branch_name}</td>
                          <td><center>{c.type_value}</center></td>
                          <td><center>{c.name}</center></td>
                          <td><center align='right'>{point}</center></td>
                          <td><center></center></td>
                          <td>{'Rs. '+invoice_value}</td>
                          <td><center align='right'>{closing_total}</center></td>
                          <td><center>{}</center></td>
                        </tr>
                      )
                    }
                  }
                  else {
                    if (c.method == 'branch') {
                      return (
                        <tr id='pointer' onClick={ () => { this.setState({ open: true, dis: c.description }) } } style={{backgroundColor: backgroundColor}}>
                          <td><center>{j++}</center></td>
                          <td>{c.branch_id+'->'+c.branch_name}</td>
                          <td><center>{c.type_value}</center></td>
                          <td><center>{c.name}</center></td>
                          <td><center></center></td>
                          <td><center align='right'>{point}</center></td>
                          <td>{'Rs. '+invoice_value}</td>
                          <td><center align='right'>{closing_total}</center></td>
                          <td><center>{'Remarks'}</center></td>
                        </tr>
                      )
                    }
                    else {
                      return (
                        <tr id='pointer' onClick={ () => { this.setState({ open: true, dis: c.description }) } } style={{backgroundColor: backgroundColor}}>
                          <td><center>{j++}</center></td>
                          <td>{c.branch_id+'->'+c.branch_name}</td>
                          <td><center>{c.type_value}</center></td>
                          <td><center>{c.name}</center></td>
                          <td><center align='right'>{point}</center></td>
                          <td><center></center></td>
                          <td>{'Rs. '+invoice_value}</td>
                          <td><center align='right'>{closing_total}</center></td>
                          <td><center>{'Remarks'}</center></td>
                        </tr>
                      )
                    }
                  }
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button color='blue' onClick={ () => { this.setState({ openDialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default View;
